import {
  APP_INITIALIZER,
  ApplicationConfig,
  inject,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { AuthenticationService } from './shared/services/auth/authentication.service';
import { errorInterceptor } from './core/interceptors/error.interceptor';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { requestHeadersInterceptor } from './core/interceptors/request-headers.interceptor';
import { STORAGE_MANAGER_TOKEN } from './core/utils/storage/storageManager';
import { LocalStorageManager } from './core/utils/storage/localStorageManager';
import { IndexDbStorageManager } from './core/utils/storage/indexDbStorageManager';
import { provideCharts, withDefaultRegisterables } from 'ng2-charts';

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(
      withInterceptors([errorInterceptor, requestHeadersInterceptor]),
    ),
    provideAnimationsAsync(),
    {
      provide: APP_INITIALIZER,
      useFactory: () => {
        const authenticationService: AuthenticationService = inject(
          AuthenticationService,
        );
        authenticationService.checkSession();
      },
    },
    {
      provide: STORAGE_MANAGER_TOKEN,
      useFactory: () => {
        return new IndexDbStorageManager();
      },
    },
    provideCharts(withDefaultRegisterables())
  ],
};
